module.exports = __webpack_public_path__ + "ptc_momoro_T2.aa4c6f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_T2.jpg
// module id = i5Gx
// module chunks = 0